// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const fermentationTargetStartWeightArchiveFermentationId = (z.number());
export const fermentationTargetStartWeightArchive = z.object({
    fermentation_id: fermentationTargetStartWeightArchiveFermentationId,
    target_starting_weight_kg: z.string().nullable(),
});
export const fermentationTargetStartWeightArchiveInitializer = z.object({
    fermentation_id: fermentationTargetStartWeightArchiveFermentationId,
    target_starting_weight_kg: z.string().optional().nullable(),
});
export const fermentationTargetStartWeightArchiveMutator = z.object({
    fermentation_id: fermentationTargetStartWeightArchiveFermentationId.optional(),
    target_starting_weight_kg: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationTargetStartWeightArchive.js.map